
    import * as React from 'react';

    const SoundOff36 = ({ color = 'currentcolor', height = '36px', width = '36px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 36 36" fill="none" style={svgStyle}><circle cx={18} cy={18} r={18} fillOpacity={0.7} /><path d="M7.875 13.7392V21.5109H11.3424L18.337 27.2501V8L11.3424 13.7392H7.875Z" fill="white" /><path d="M28.2 14.9113L27.39 14L24.6 17.1387L21.81 14L21 14.9113L23.79 18.05L21 21.1887L21.81 22.1L24.6 18.9613L27.39 22.1L28.2 21.1887L25.41 18.05L28.2 14.9113Z" fill="white" /></svg>
        </div>
      );
    };

    SoundOff36.displayName = 'SoundOff36';

    export default SoundOff36;
  